import { render, staticRenderFns } from "./SSOAuth.vue?vue&type=template&id=3173abaa"
import script from "./SSOAuth.vue?vue&type=script&lang=js"
export * from "./SSOAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports